import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1881698648/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/category/(components)/content.tsx");
